import { sanitizeHtml } from '../../../src/helpers/sanitizeHtml';
import { sanitizeHtmlAttr } from '../../../src/helpers/sanitize';

const TAGS_PERMITIDAS_TOAST = ['a', 'b', 'strong', 'i', 'em', 'u', 's', 'del', 'br', 'hr', 'p', 'span', 'ul', 'ol', 'li'];
const ATRIBUTOS_PERMITIDOS_TOAST = ['href', 'class', 'target', 'rel'];
const TARGETS_PERMITIDOS = ['_self', '_blank'];
const HREF_PERMITIDO = /^(\/(?![/\\])|#|https?:|mailto:)/i;

function sanitizaMensagem(mensagem) {
  return sanitizeHtml(String(mensagem ?? ''), {
    ALLOWED_TAGS: TAGS_PERMITIDAS_TOAST,
    ALLOWED_ATTR: ATRIBUTOS_PERMITIDOS_TOAST,
    ALLOW_DATA_ATTR: false
  });
}

function hrefSeguro(href) {
  const valor = String(href ?? '').replace(/[\t\n\r]/g, '').trim();
  return sanitizeHtmlAttr(HREF_PERMITIDO.test(valor) ? valor : '#');
}

function atributoTarget(target) {
  return TARGETS_PERMITIDOS.includes(target) ? `target="${target}"` : '';
}

export function generateContentTemplate({ colorIcon, icon, title, mensagem, hasTimer, actionButton }) {
  return `
    <div class="toast-content">
      <span class="toast-title">
        <svg class="icon fill-${colorIcon}" width="16" height="16">
          <use href="#icon-${icon}"></use>
        </svg>
        <span>${sanitizeHtmlAttr(title)}</span>
      </span>
      <span class="toast-message">${sanitizaMensagem(mensagem)}</span>
      ${actionButton ? `
        <a href="${hrefSeguro(actionButton.href)}" class="toast-action-button text-maino-green font-weight-700 mt-1" ${atributoTarget(actionButton.target)}>
          ${sanitizeHtmlAttr(actionButton.label)}
        </a>
      ` : ''}
    </div>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" onclick="close_toast(this)">
      <svg class="icon fill-cinza-5" width="20" height="20"><use href="#icon-x-mark"></use></svg>
    </button>
  `;
}

export function generateProgressBarTemplate(colorIcon) {
  return `
    <div class="progress-bar">
      <div class="progress-bar-inner" style="width: 0%; background-color: var(--${colorIcon});"></div>
    </div>
  `;
}

export function generateToastTemplate({ classe, content, barraProgresso, hasTimer, toastId }) {
  return `
    <div class="maino-toast ${classe}" data-toast-id="${toastId}">
      ${hasTimer
        ? `
          <div class="toast-container">
            ${content}
            ${barraProgresso}
          </div>
        `
        : content
      }
    </div>
  `;
}
